import { inject, Pipe, PipeTransform } from '@angular/core';
import { NewsCategory } from './models/news-category.enum';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'newsCategory',
  pure: false
})
export class NewsCategoryPipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(value: NewsCategory): string {
    const enumName = value.toString().toLowerCase();
    return this.translate.instant(`news.categories.${enumName}`);
  }

}
